<template>
	<div>
		<botao-voltar label-voltar="Voltar para listagem" :nome-rota-anterior="rotaListagem"></botao-voltar>
		<az-container>
			<v-card elevation="0">
				<v-card-text>
					<formulario-revisao :id-revisao="idRevisao" visualizacao></formulario-revisao>
				</v-card-text>
			</v-card>
		</az-container>
	</div>
</template>

<script>
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import { routesNames } from '@/core/constants'
import FormularioRevisao from '@/views/pages/configuracao/revisoes/formulario-revisao/FormularioRevisao.vue'

export default {
	name: 'revisao-visualizacao',
	components: { FormularioRevisao, BotaoVoltar },
	data() {
		return {
			idRevisao: Number(this.$route.params.id),
			rotaListagem: routesNames.CONFIGURACAO.REVISOES.REVISOES_VIEW,
		}
	},
}
</script>

<style scoped lang="stylus"></style>
